<div class="container">
  @if (withLabel) {
    <ion-label [ngClass]="baseCssClass">Status:</ion-label>
  }

  @if (disabled) {
    <rc-order-status-badge [orderStatus]="fieldValue"></rc-order-status-badge>
  }

  @if (!disabled) {
    <ion-select
      [ngClass]="baseCssClass"
      [value]="fieldValue"
      placeholder="Select a value"
      (ionChange)="onInputChange($event)">
      @for (value of orderStatusValues; track value) {
        <ion-select-option [value]="value">{{ value }}</ion-select-option>
      }
    </ion-select>
  }
</div>
